import { LocalStorageContainer } from '../../../shared/src/helpers/LocalStorageContainer';
import { SESSION_ID } from './SessionID';

export class PersistentBookmarks {
  private static _container = new LocalStorageContainer<PersistentBookmarks.LocalStorage.Model>(
    '__BOOKMARKS__'
  );

  static load = (): PersistentBookmarks.LocalStorage.Model => {
    return PersistentBookmarks._container.get() ?? [];
  };

  static save = (items: PersistentBookmarks.LocalStorage.Item[]) => {
    if (items.length === 0) {
      return;
    }

    try {
      const newList = {
        id: SESSION_ID,
        date: +new Date(),
        items: items.map(({ name, sum }) => ({ name: name.trim(), sum: sum })),
      };

      const bookmarks = PersistentBookmarks.load();

      const lists = bookmarks.map(savedList => (savedList.id === SESSION_ID ? newList : savedList));

      if (!lists.find(list => list.id === SESSION_ID)) {
        lists.push(newList);
      }

      this._container.set(lists);
    } catch (e) {}
  };

  static delete = (id: number) => {
    const history = PersistentBookmarks.load();

    this._container.set(history.filter(list => list.id !== id));
  };
}

export namespace PersistentBookmarks {
  export namespace LocalStorage {
    export type Item = {
      name: string;
      sum: number;
    };

    export type List = {
      id: number;
      date: number;
      items: Item[];
    };

    export type Model = PersistentBookmarks.LocalStorage.List[];
  }
}
